import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * Lets pages that are not provider-scoped by URL (dashboard, shared league)
 * tell the global footer which providers' data they are showing, so the
 * footer can render the required attribution line.
 */
const AttributionContext = createContext({
  providers: [],
  setProviders: () => {},
});

export const AttributionProvider = ({ children }) => {
  const [providers, setProvidersState] = useState([]);
  const setProviders = useCallback((next) => {
    const normalized = Array.from(
      new Set((next || []).map((p) => String(p || '').trim().toLowerCase()).filter(Boolean))
    ).sort();
    setProvidersState((prev) =>
      prev.length === normalized.length && prev.every((p, i) => p === normalized[i])
        ? prev
        : normalized
    );
  }, []);
  const value = useMemo(() => ({ providers, setProviders }), [providers, setProviders]);
  return <AttributionContext.Provider value={value}>{children}</AttributionContext.Provider>;
};

export const useAttribution = () => useContext(AttributionContext);

export default AttributionContext;
